import { StatsCard } from '@/components/ui/stats-card';
import { formatChangeVsPrevious, SUBJECT_TYPE_LABELS } from '@/features/abuse/abuse-meta';
import { ABUSE_SUBJECT_TYPES, type AbuseSummary } from '@/services/api/abuse';

interface SummaryProps {
  summary: AbuseSummary | undefined;
  isLoading: boolean;
}

export const SummaryTiles = ({ summary, isLoading }: SummaryProps) => {
  const totals = summary?.totals;
  const crossingSplit = totals ? ABUSE_SUBJECT_TYPES.map((type) => `${SUBJECT_TYPE_LABELS[type]} ${totals.crossingsBySubjectType[type]}`).join(' · ') : undefined;

  return (
    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
      <StatsCard
        isLoading={isLoading}
        label="Events"
        subtitle={totals ? (formatChangeVsPrevious(totals.events, totals.previousEvents) ?? undefined) : undefined}
        value={totals?.events ?? '—'}
      />
      <StatsCard isLoading={isLoading} label="Threshold crossings" subtitle={crossingSplit} value={totals?.crossings ?? '—'} />
      <StatsCard
        isLoading={isLoading}
        label="Active accounts"
        subtitle={totals ? `${totals.activeSubjects.apiKey} API keys` : undefined}
        value={totals?.activeSubjects.user ?? '—'}
      />
      <StatsCard isLoading={isLoading} label="Active IPs" value={totals?.activeSubjects.ip ?? '—'} />
    </div>
  );
};
SummaryTiles.displayName = 'SummaryTiles';
